// File: clientService.ts
// ==============================================================================
// VERSION INFORMATION
// ==============================================================================
// __version__ = "1.1.1"
//
// Changelog:
//
// Version 1.1.1:
// - [Fixed] Added `getMyGroups` to the exported object to fix a build error.
//
// Version 1.1.0:
// - [Added] `getMyGroups` function to fetch groups for the authenticated client.
//
// Version 1.0.0:
// - Initial version of the client service.
// ==============================================================================
import apiClient from './api';
import { ClientProfile, ClientGroup } from '../types';

// Payload for updating client profile
export interface ClientProfileUpdatePayload {
  phone_number?: string | null;
  date_of_birth?: string | null; // YYYY-MM-DD
  long_term_goals_summary?: string | null;
  background_info?: string | null;
  preferences?: string | null;
  // coach_id can't be updated by client directly here
  // coach_private_notes only updatable by coach
}


const getMyProfile = async (): Promise<ClientProfile> => {
  const { data } = await apiClient.get<ClientProfile>('/clients/me/profile');
  return data;
};

const updateMyProfile = async (payload: ClientProfileUpdatePayload): Promise<ClientProfile> => {
  const { data } = await apiClient.put<ClientProfile>('/clients/me/profile', payload);
  return data;
};

const getMyGroups = async (): Promise<ClientGroup[]> => {
  const { data } = await apiClient.get<ClientGroup[]>('/clients/me/groups');
  return data;
};

export default {
  getMyProfile,
  updateMyProfile,
  getMyGroups,
};